import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import SummaryDiscussionHistoryPage from 'model/SummaryDiscussionHistoryPage'

export class SummaryDiscussionHistoryPagesRepository extends WebRepository<
  SummaryDiscussionHistoryPage
> {
  constructor() {
    super(new Api('appointments'))
  }

  async searchSummaryDiscussionHistoryPage(
    selector: any,
    bookmark: string,
  ): Promise<SummaryDiscussionHistoryPage> {
    // important
    const condSummaryImportant = selector.summaryImportant
      ? { summaryImportant: selector.summaryImportant }
      : {}

    return super.searchPage({
      selector: {
        patientId: selector.patientId,
        logs: { $elemMatch: { summary: { $ne: '' }, ...condSummaryImportant } },
      },
      sort: {
        startDateTime: -1,
      },
      limit: 10,
      bookmark: bookmark,
    })
  }
}

export default new SummaryDiscussionHistoryPagesRepository()
